export default __webpack_public_path__ + "static/media/ico-bookmark-active-sm.01be39b0.svg";